var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Math.abs(_vm.diff) > 0.0001)?_c('span',{class:_vm.diffClass},[_vm._v(_vm._s(_vm.format(_vm.diff, _vm.filter)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }